import React from 'react';
import styled from 'styled-components';

const Author = ({ name }) => <Wrapper>{name}</Wrapper>;

const Wrapper = styled.div`
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid white;
`;

export default Author;
